export default "__VITE_ASSET__CvzMxQqA__"